<template>
  <div class="text-xs-center snackbar-container">
    <v-snackbar v-model="snackbar"
                :color="color"
                :timeout="snackTimeout"
                bottom
                app>
      {{ snackMessage }}
      <template v-slot:action="{ attrs }">
        <v-btn dark text @click="close" v-bind="attrs">
          <v-icon>close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  props: ['snackMessage', 'snackColor', 'snackDuration', 'isVisible'],
  data: () => ({
    closed: false,
  }),
  computed: {
    snackbar: {
      get() {
        return this.isVisible && !this.closed;
      },
      set(val) {
        if (!val) {
          this.close();
        }
      },
    },
    snackTimeout() {
      if (this.snackColor === 'error') {
        return 0;
      }
      return this.snackDuration ? this.snackDuration : 5000;
    },
    color() {
      if (this.snackColor) {
        return this.snackColor;
      }
      return 'success';
    },
  },
  methods: {
    close() {
      this.closed = true;
      this.$emit('dismissed');
    },
  },
};
</script>

<style>
  .snackbar-container {
    width: 100%;
  }
</style>
